import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum BodyType {
  AVERAGE = "average",
  CHUBBY = "chubby",
  FIT = "fit",
  LARGE = "large",
  MUSCULAR = "muscular",
  SLIM = "slim",
  STOCKY = "stocky",
  TONED = "toned",
  OTHER = "other",
  ASK_ME = "ask_me",
}

const BODY_ATTRIBUTE_OPTIONS: ReadonlyArray<AttributeValue> = [
  { id: BodyType.AVERAGE, label: "Average", iconLabel: "◯" },
  { id: BodyType.CHUBBY, label: "Chubby", iconLabel: "⬤" },
  { id: BodyType.FIT, label: "Fit", iconLabel: "△" },
  { id: BodyType.LARGE, label: "Large", iconLabel: "⬛" },
  { id: BodyType.MUSCULAR, label: "Muscular", iconLabel: "♦" },
  { id: BodyType.SLIM, label: "Slim", iconLabel: "│" },
  { id: BodyType.STOCKY, label: "Stocky", iconLabel: "▼" },
  { id: BodyType.TONED, label: "Toned", iconLabel: "⬟" },
  { id: BodyType.OTHER, label: "Other", iconLabel: "?" },
  { id: BodyType.ASK_ME, label: "Ask Me", iconLabel: "❓" },
];

export const UserBodyAttributeSet: UserAttributeSet = {
  id: UserAttributeType.BODY,
  isMultiSelect: false,
  map: attributeListToMap(BODY_ATTRIBUTE_OPTIONS),
} as const;
